export default {
  title_one: 'Leveringsstatistik opdateres for „{{title}}“',
  title_other: 'Leveringsstatistik opdateres for {{count}} kampagner',
  subtitle_pending:
    'Apple og Google bekræfter modtagelse om ca. {{minutes}} min. {{seconds}} sek. (omkring kl. {{time}}). Statistikken opdateres automatisk.',
  subtitle_ready: 'Kvitteringerne burde være modtaget. Opdater siden for at se de seneste leveringstal.',
};
